import React from 'react';
import { PAGETYPE_TO_TOUCHPOINT } from '@constants/welcome-voucher';
import useWelcomeVoucherQuery from '@hooks/user/use-welcome-voucher-query';
import useProductShippingQuery from '@hooks/product/use-product-shipping-query';
import useProductQuery from '@hooks/product/use-product-query';
import usePageType from '@hooks/use-page-type';
import dynamic from 'next/dynamic';
import { WelcomeVoucherProps } from '@components/catalog/welcome-voucher/welcome-voucher';

const WelcomeVoucher = dynamic(() => import('@components/catalog/welcome-voucher/welcome-voucher'));

const WelcomeVoucherWrapper: React.FC<WelcomeVoucherProps> = (props) => {
  const { product, userTransactionRole } = useProductQuery();
  const { pageType } = usePageType();

  const { welcomeVoucher } = useWelcomeVoucherQuery({
    touchPoint: PAGETYPE_TO_TOUCHPOINT[pageType],
    productId: product?.id,
  });
  const { isProductShippable } = useProductShippingQuery();
  const shouldShowWelcomeVoucher: boolean =
    welcomeVoucher && welcomeVoucher?.text && isProductShippable && !product.sold && userTransactionRole === 'buyer';

  if (!shouldShowWelcomeVoucher) {
    return null;
  }

  return (
    <WelcomeVoucher
      {...props}
      productId={product?.id}
    />
  );
};

export default WelcomeVoucherWrapper;
